import { Injectable } from '@angular/core';

import { Consorcio } from '../model/Consorcio';
import { Sucursal } from '../model/sucursal';
import { ReporteInventario } from '../model/reporte-inventario';
import { IlgReporteInventario } from '../model/ilg-reporte-inventario';
import { ReporteLote } from '../model/reporte-lote';
import { ReporteInventarioSeries } from '../model/reporte-inventario-series';
import { ReporteArticulos } from '../model/reporte-articulos';
import { ReporteListaEmpaque } from '../model/reporte-lista-empaque';
import { ReporteArticulosSupreme } from '../model/reporte-articulos-supreme';
import { ReporteMovimientosSupreme } from '../model/reporte-movimientos-supreme';
import { ReporteRecepcionesSupreme } from '../model/reporte-recepciones-supreme';
import { ReporteRecepcionesDiarias } from '../model/reporte-recepciones-diarias';
import { ReportePosiciones } from '../model/reporte-posiciones';

import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/timeout';
import { Observable } from 'rxjs/Observable';

import { UtilitiesService } from '../services/utilities.service'
@Injectable()
export class ReporteInventarioService {

  constructor(private _http: Http,
    private _utilities: UtilitiesService) { }

  getInventario(query: any): Observable<ReporteInventario[]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

   getArticulosGeneral(query: any): Observable<ReporteArticulos[]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  getInventarioSeries(query: any): Observable<[ReporteInventarioSeries]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  getInventarioLote(query: any): Observable<[ReporteLote]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });


    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  getListaEmpaque(query: any): Observable<[ReporteListaEmpaque]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });


    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  getArticulosSupreme(query: any): Observable<[ReporteArticulosSupreme]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  getMovimientosSupreme(query: any): Observable<[ReporteMovimientosSupreme]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json()).timeout(300000);

  }

  
  getRecepcionesSupreme(query: any): Observable<[ReporteRecepcionesSupreme]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json()).timeout(300000);

  } 

  getRecepcionesDiarias(query: any): Observable<[ReporteRecepcionesDiarias]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json()).timeout(300000);

  }

  getIlgReporteInventario(query: any): Observable<[IlgReporteInventario]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json()).timeout(300000);

  }

   getReportePosiciones(query: any): Observable<[ReportePosiciones]> {

    let json = { "Metodo": "getReportes", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json()).timeout(300000);

  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/reporte-inventario.service.ts